'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.getCategoryAlias = getCategoryAlias;
exports.reloadCourseList = reloadCourseList;
exports.loadMoreCourseList = loadMoreCourseList;
var GET_CATEGORY_ALIAS = 'career/list/GET_CATEGORY_ALIAS';
var GET_CATEGORY_ALIAS_SUCCESS = 'career/list/GET_CATEGORY_ALIAS_SUCCESS';
var GET_CATEGORY_ALIAS_FAIL = 'career/list/GET_CATEGORY_ALIAS_FAIL';

var RELOAD_COURSE_LIST = 'career/list/RELOAD_COURSE_LIST';
var RELOAD_COURSE_LIST_SUCCESS = 'career/list/RELOAD_COURSE_LIST_SUCCESS';
var RELOAD_COURSE_LIST_FAIL = 'career/list/RELOAD_COURSE_LIST_FAIL';

var LOAD_MORE_COURSE_LIST = 'career/list/LOAD_MORE_COURSE_LIST';
var LOAD_MORE_COURSE_LIST_SUCCESS = 'career/list/LOAD_MORE_COURSE_LIST_SUCCESS';
var LOAD_MORE_COURSE_LIST_FAIL = 'career/list/LOAD_MORE_COURSE_LIST_FAIL';

var initialState = {
    alias: [],
    courseList: [],
    pager: {},
    loading: true
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_CATEGORY_ALIAS_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                alias: action.result.data.data
            });
        case RELOAD_COURSE_LIST:
            return _extends({}, state, {
                courseList: [],
                pager: {},
                loading: true
            });
        case RELOAD_COURSE_LIST_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                loading: false,
                courseList: action.result.data.data,
                pager: action.result.data.pager
            });
        case LOAD_MORE_COURSE_LIST_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                courseList: state.courseList.concat(action.result.data.data),
                pager: action.result.data.pager
            });
        default:
            return state;
    }
}

function getCategoryAlias(type) {
    return {
        types: [GET_CATEGORY_ALIAS, GET_CATEGORY_ALIAS_SUCCESS, GET_CATEGORY_ALIAS_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/bp/course/category-alias?categoryType=' + type);
            }

            return promise;
        }()
    };
}

function _createQuery(state, type, id) {
    var query = {
        page: state.pager ? state.pager.page + 1 : 1,
        size: state.pager && state.pager.size ? state.pager.size : 15,
        categoryType: type,
        categoryId: id
    };
    return query;
}

function _reloadCourseList(query) {
    return {
        types: [RELOAD_COURSE_LIST, RELOAD_COURSE_LIST_SUCCESS, RELOAD_COURSE_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/course/list', query);
            }

            return promise;
        }()
    };
}

function reloadCourseList(type, id) {
    return function (dispatch, getState) {
        var state = getState().careerList;
        state.pager = null;
        var query = _createQuery(state, type, id);
        dispatch(_reloadCourseList(query));
    };
}

function _loadMoreCourseList(query, callback) {
    return {
        types: [LOAD_MORE_COURSE_LIST, LOAD_MORE_COURSE_LIST_SUCCESS, LOAD_MORE_COURSE_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/course/list', query);
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (callback) {
                    callback();
                }
            }

            return afterSuccess;
        }()
    };
}

function loadMoreCourseList(type, id, callback) {
    return function (dispatch, getState) {
        var state = getState().careerList;
        if (state.pager && state.pager.page && state.pager.page == state.pager.totalPages) {
            return;
        }
        var query = _createQuery(state, type, id);
        dispatch(_loadMoreCourseList(query, callback));
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/career/careerList.js
// module id = 497
// module chunks = 0